import { render, staticRenderFns } from "./__EmailVerification.vue?vue&type=template&id=97c9a130"
import script from "./__EmailVerification.vue?vue&type=script&lang=js"
export * from "./__EmailVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports